import { Button } from '@components'
import { PermissionSet, usePermission } from '@context'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FaBook, FaCheck, FaPen } from 'react-icons/fa'
import { SuggestionFooter, SuggestionFooterSection } from '../styles'

interface SuggestionCardFooterProps {
  isLoading: boolean
  isDefaultRuleLoading: boolean
  formId: string
  onEdit: () => void
  onAutomate: () => void
  isRuleWaitingForAttachment?: boolean
}

export const SuggestionCardFooter: React.FC<SuggestionCardFooterProps> = ({
  isLoading,
  isDefaultRuleLoading,
  formId,
  onEdit,
  onAutomate,
  isRuleWaitingForAttachment = false
}) => {
  const hasEditPermission = usePermission(PermissionSet.BOOKKEEPING_EDIT)
  const hasAutomationPermission = usePermission(PermissionSet.BOOKKEEPING_ADMIN)
  const { t } = useTranslation()

  return (
    <SuggestionFooter>
      {hasEditPermission && (
        <>
          <SuggestionFooterSection>
            <Button disabled={isLoading} onClick={onEdit} icon={<FaPen />} size="sm">
              {t('general.edit')}
            </Button>
            {hasAutomationPermission && !isRuleWaitingForAttachment && (
              <Button
                onClick={onAutomate}
                icon={<FaBook />}
                size="sm"
                disabled={isDefaultRuleLoading}
                showSpinner={isDefaultRuleLoading}
              >
                {t('document.suggestionCard.automate')}
              </Button>
            )}
          </SuggestionFooterSection>

          <SuggestionFooterSection>
            <Button
              intent="success"
              type="submit"
              form={formId}
              disabled={isLoading}
              showSpinner={isLoading}
              iconRight={<FaCheck />}
              size="sm"
            >
              {t('document.acceptSuggestion')}
            </Button>
          </SuggestionFooterSection>
        </>
      )}
    </SuggestionFooter>
  )
}
